module.exports = __webpack_public_path__ + "static/whywe_logo-5244d63b9a7bd88b671455986a845e06.png";